import DeleteTradeReference from "./DeleteTradeReference";

export default DeleteTradeReference;
